import React from "react";
import "./MockInterviewers.css"; // Reuse layout styles
import interImg from "../Images/inter.jpg"; // Replace with a dedicated image if available
import { Link } from 'react-router-dom';

const MockInterviewers = () => {
  return (
    <main className="sh-landing-container">
      <br /><br /><br /><br /><br />

      {/* Mock Interviewers Section */}
      <section className="sh-section reverse">
        <div className="sh-img-left-moc">
          <img src={interImg} alt="Mock Interviewers" />
        </div>
        <div className="sh-text-right-moc">
          <h2>MOCK INTERVIEWERS</h2>
          <p className="tag">Support future hires with industry-grade mock interviews and learn while you lead</p>
          <p className="tag1">
            Engineering Managers, <br /> Senior Developers, Hiring  <br />Professionals
            and <span className="hh">Domain Experts</span>
          </p>

          <p className="tag2">
            Help us bring hiring room realism to our mock interview process. Conduct domain-specific interviews, give feedback, and help candidates prepare better. Your expertise helps us create stronger, job-ready candidates.
          </p>
          {/* <a
              href="https://forms.gle/B9ZHm3azzM9suzsN9"
              target="_blank"
              rel="noopener noreferrer"
            > */}
          <Link to="/RedirectToForm"><button className="sh-secondary-btn">Connect Now</button></Link>
          {/* </a> */}
        </div>
      </section>
    </main>
  );
};

export default MockInterviewers;
